export default "__VITE_ASSET__cd78b889__"